import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagUsoPresupuestoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='flagUsoPresupuesto'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagUsoPresupuesto'
              label='Uso presupuesto'
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagUsoPresupuestoFormGroup)
